import CircularProgress from '@mui/material/CircularProgress'

export default function LoaderIndicator(props) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexFlow: 'column', width: '100%' }}>
            <p>{props.text ?? "Загрузка модуля..."}</p>
            <CircularProgress color="inherit" />
        </div>
    )
}